export default __webpack_public_path__ + "static/media/Delete.3a538ade.svg";